@import '~style-sheet-helpers/core.less';

.data-driven-logo-column {
  width: 100%;
  font-size: 13px;
  height: 30px;

  &.multiple {
    .truncate();
    line-height: 30px;
  }
}

.normal-content {
  width: 100%;
  height: 100%;
  display: flex;
}

.data-driven-logo {
  height: 20px;
  width: 20px;
  align-self: center;
}

.message {
  .truncate();
  width: calc(100% ~'-' 35px);
  margin-left: 5px;
  line-height: 30px;
}
